import CryptoJS from 'crypto-js'

const secretKey = 'abc123'

// 文本加密
export function encryptText(text) {
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString()

  return ciphertext
}

// 文本解密
export function decryptText(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
  const originalText = bytes.toString(CryptoJS.enc.Utf8)

  return originalText
}

// 对象加密
export function encryptObject(data) {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString()

  return ciphertext
}

// 对象解密
export function decryptObject(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

  return decryptedData
}
